import { useState } from 'react'
import { Item } from '@react-stately/collections'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import { TextArea } from 'almanac-ui/TextInputField/Input'
import { Select } from 'components/Select/Select'
import { STAR_RATING_ISSUE_TYPES } from './starRatingConstants'
import Styles from './StarRatingFeedbackForm.module.scss'

interface StarRatingFeedbackFormProps {
  onSubmit: (issueType?: string, comment?: string) => void
  onSkip: () => void
}

export const StarRatingFeedbackForm = ({ onSubmit, onSkip }: StarRatingFeedbackFormProps) => {
  const [issueType, setIssueType] = useState('')
  const [comment, setComment] = useState('')

  const handleSubmit = () => {
    onSubmit(issueType || undefined, comment || undefined)
  }

  return (
    <>
      <div className={Styles.field}>
        <div className={Styles.label}>
          <Text variant="secondary" color="var(--dark-90)">
            Issue type
          </Text>
          <Text variant="secondary" color="var(--dark-40)">
            (optional)
          </Text>
        </div>
        <Select
          selectedKey={issueType || undefined}
          onSelectionChange={(key) => setIssueType(key as string)}
          placeholder="Select an issue type"
          variant="secondary"
          useFullWidth
        >
          {STAR_RATING_ISSUE_TYPES.map(({ key, label }) => (
            <Item key={key}>{label}</Item>
          ))}
        </Select>
      </div>

      <div className={Styles.field}>
        <div className={Styles.label}>
          <Text variant="secondary" color="var(--dark-90)">
            Comment
          </Text>
          <Text variant="secondary" color="var(--dark-40)">
            (optional)
          </Text>
        </div>
        <TextArea
          name="star-rating-comment"
          size="sm"
          rows={3}
          resizable={false}
          value={comment}
          placeholder="Tell us more..."
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setComment(e.target.value)}
        />
      </div>

      <div className={Styles.buttonRow}>
        <Button variant="tertiary" size="sm" onPress={onSkip}>
          Skip Comment
        </Button>
        <Button variant="primary" size="sm" onPress={handleSubmit}>
          Submit
        </Button>
      </div>
    </>
  )
}
